import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Create a store for map-related state
export const useBoundingBoxStore = create(
  persist(
    (set) => ({
      // Initial center coordinates
      ne: { lat: 51.505, lng: -0.09 },
      sw: { lat: 51.505, lng: -0.09 },
      
      // Method to update center coordinates
      setNE: (coordinatesNE) => set({ ne: coordinatesNE }),
      
      // Method to update zoom level
      setSW: (coordinatesSW) => set({ sw: coordinatesSW }),
      
      // Combined update for when both change simultaneously
      updateBoundingBox: (ne, sw) => set({ ne, sw }),
    }),
  {
    name:"boundingBox-store"
  })
);

export const useBoundingBoxStoreRelative = create(
  persist(
    (set) => ({
      // Initial state
      boundingBox: {
        minX: 0,
        minY: 0,
        maxX: 0,
        maxY: 0,
      },

      // Update method
      updateBoundingBox: (minX, minY, maxX, maxY) =>
        set({
          boundingBox: { minX, minY, maxX, maxY },
        }),
    }),
    {
      name: "boundingBox-store-relative",
    }
  )
)

